<div class="card shadow-lg requestCard mb-3">
  <div class="card-body">
    <h2>
      <strong>{{ transactionRequest.CompanyCode }}</strong>
    </h2>
    <hr />
    <span
      ><strong>Remark: {{ transactionRequest.Remark }}</strong></span
    >
    <table class="table table-bordered table-custom p-0 m-0">
      <thead>
        <tr>
          <th>Type</th>
          <th>Amount</th>
        </tr>
      </thead>

      <tbody>
        @for (item of transactionRequest.TransactionItems; track item) {
          <tr>
            <td>{{ enums.transactionTypeString[item.type - 1] }}</td>
            <td>RM {{ item.amount }}</td>
          </tr>
        }
      </tbody>
      <tfoot>
        <tr>
          <th></th>
          <th>RM {{ calculateTotal() }}</th>
        </tr>
      </tfoot>
    </table>

    <div class="row">
      <div class="col d-flex justify-content-end align-items-right">
        @if (this.sharedService.isBossAccount()) {
          <button class="btn btn-danger" (click)="confirmBeforeDelete(transactionRequest)"><i class="fas fa-trash-alt"></i> Delete</button>
        }

        @if (this.sharedService.isBranchAccountHandler()) {
          <button class="btn btn-success" (click)="openAddTrasactionIntoAccountModal()"><i class="fas fa-plus"></i> Add Into Account</button>
        }
      </div>
    </div>
  </div>
</div>
